import * as style from './style.css';
import { ProductIndexCard } from '../../pages/catalog/productIndexCard/ProductIndexCard';
import { ActionT2 } from '../../framework/framework/components/Types';
import { IProductIndexModel } from '../../pages/catalog/productIndexCard/IProductItemModel';
import React = require('react');

interface IProps {
    models: IProductIndexModel[];
    buyClick?: ActionT2<number, string>;
}
interface IState {
    index: number;
}

export default class ProductsSlider extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);
        this.state = {
            index: 0
        };
    }

    render() {
        const models = this.props.models;
        return (
            <div className={style.slider}>
                <div className={style.accessoryContainer}>
                    {models.map((p) =>

                        <ProductIndexCard
                            key={p.uri}
                            item={p}
                            buyClick={(id, name) => this.handleBuyClick(id, name)}
                        />

                    )}
                </div>
            </div>
        );
    }

    handleBuyClick(id: number, name: string): void {
        if (this.props.buyClick) { this.props.buyClick(id, name); }
    }
}
